import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import { isMobileDevice } from '@src/quince-site-common/src/helpers/getDeviceTypeForPageRouter'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

import Layout from '../layout'

import Wishlist from './wishlist-page'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.WISHLIST)
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageWishlist(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>
      {props.pageData ? (
        <Wishlist data={props.pageData} isMobile={isMobileDevice(props.deviceType)} />
      ) : (
        <SomethingWentWrong />
      )}
    </Layout>
  )
}
